var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackEnd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 121,
    viewBox: "0 0 121 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 16.8887H103.448V45.8542H0V16.8887ZM4.13793 21.0266V41.7163H99.3103V21.0266H4.13793Z",
    fill: "url(#paint0_linear_935_3328)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.587 12.7512H10.3457V8.61328H111.725V35.5098H107.587V12.7512Z",
    fill: "#A7BDF7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.862 4.47485H18.6211V0.336914H120V27.2335H115.862V4.47485Z",
    fill: "#D3DEFB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 54.1299H103.448V83.0954H0V54.1299ZM4.13793 58.2678V78.9575H99.3103V58.2678H4.13793Z",
    fill: "url(#paint1_linear_935_3328)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.724 45.8545V74.82H107.586V45.8545H111.724Z",
    fill: "#A7BDF7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.001 37.5781V66.5436H115.863V37.5781H120.001Z",
    fill: "#D3DEFB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.724 83.0957V112.061H107.586V83.0957H111.724Z",
    fill: "#A7BDF7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.001 74.8193V103.785H115.863V74.8193H120.001Z",
    fill: "#D3DEFB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 91.3711H103.448V120.337H0V91.3711ZM4.13793 95.509V116.199H99.3103V95.509H4.13793Z",
    fill: "url(#paint2_linear_935_3328)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.8625 35.5093C58.1479 35.5093 60.0005 33.6566 60.0005 31.3713C60.0005 29.086 58.1479 27.2334 55.8625 27.2334C53.5772 27.2334 51.7246 29.086 51.7246 31.3713C51.7246 33.6566 53.5772 35.5093 55.8625 35.5093Z",
    fill: "url(#paint3_linear_935_3328)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.4133 35.5093C74.6986 35.5093 76.5513 33.6566 76.5513 31.3713C76.5513 29.086 74.6986 27.2334 72.4133 27.2334C70.128 27.2334 68.2754 29.086 68.2754 31.3713C68.2754 33.6566 70.128 35.5093 72.4133 35.5093Z",
    fill: "url(#paint4_linear_935_3328)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.4133 72.7505C74.6986 72.7505 76.5513 70.8979 76.5513 68.6125C76.5513 66.3272 74.6986 64.4746 72.4133 64.4746C70.128 64.4746 68.2754 66.3272 68.2754 68.6125C68.2754 70.8979 70.128 72.7505 72.4133 72.7505Z",
    fill: "url(#paint5_linear_935_3328)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.9661 35.5093C91.2514 35.5093 93.104 33.6566 93.104 31.3713C93.104 29.086 91.2514 27.2334 88.9661 27.2334C86.6807 27.2334 84.8281 29.086 84.8281 31.3713C84.8281 33.6566 86.6807 35.5093 88.9661 35.5093Z",
    fill: "url(#paint6_linear_935_3328)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.9661 72.7505C91.2514 72.7505 93.104 70.8979 93.104 68.6125C93.104 66.3272 91.2514 64.4746 88.9661 64.4746C86.6807 64.4746 84.8281 66.3272 84.8281 68.6125C84.8281 70.8979 86.6807 72.7505 88.9661 72.7505Z",
    fill: "url(#paint7_linear_935_3328)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_935_3328",
    x1: -7.30751e-7,
    y1: 43.2825,
    x2: 100.503,
    y2: 20.2802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_935_3328",
    x1: -7.30751e-7,
    y1: 80.5237,
    x2: 100.503,
    y2: 57.5215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_935_3328",
    x1: -7.30751e-7,
    y1: 117.765,
    x2: 100.503,
    y2: 94.7627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_935_3328",
    x1: 51.7246,
    y1: 34.7745,
    x2: 60.1514,
    y2: 34.2345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_935_3328",
    x1: 68.2754,
    y1: 34.7745,
    x2: 76.7022,
    y2: 34.2345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_935_3328",
    x1: 68.2754,
    y1: 72.0157,
    x2: 76.7022,
    y2: 71.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_935_3328",
    x1: 84.8281,
    y1: 34.7745,
    x2: 93.2549,
    y2: 34.2345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_935_3328",
    x1: 84.8281,
    y1: 72.0157,
    x2: 93.2549,
    y2: 71.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackEnd);
export default __webpack_public_path__ + "static/media/back-end.5eabfcbe38f3f9556656e3d41f4560ea.svg";
export { ForwardRef as ReactComponent };